var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isJoinVoip)?_c('div',{staticClass:"voip-tips",class:{ active: _vm.isVoipName }},[(!_vm.isVoipName)?[_vm._v(_vm._s(_vm.$t('tips.连麦功能已开启')))]:_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }